import React, { useState } from 'react';
import { FaStore, FaClock, FaQrcode, FaTimes, FaPlus } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { Modal } from 'react-bootstrap';
import { Coupon } from '../../types';
import AddCoupon from './components/AddCoupon/AddCoupon';
import './Cupones.scss';

const Cupones: React.FC = () => {
    const [showQRModal, setShowQRModal] = useState(false);
    const [showAddCouponModal, setShowAddCouponModal] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState<any>(null);
    
    // TODO: Replace with actual API call to fetch user's coupons
    // For production: Using empty array until backend integration
    const coupons: Coupon[] = [];
    
    const activeCoupons = coupons.filter(c => !c.is_used);
    const usedCoupons = coupons.filter(c => c.is_used);

    const formatDate = (dateString: string): string => {
        return new Date(dateString).toLocaleDateString('es-CL', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const isExpiringSoon = (dateString: string): boolean => {
        const expiryDate = new Date(dateString);
        const today = new Date();
        const daysUntilExpiry = Math.floor((expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
        return daysUntilExpiry <= 7 && daysUntilExpiry >= 0;
    };

    const handleShowQR = (coupon: any, e: React.MouseEvent) => {
        e.stopPropagation();
        setSelectedCoupon(coupon);
        setShowQRModal(true);
    };

    const handleAddCoupon = async (code: string) => {
        // TODO: Implement backend API call to add coupon
        // Placeholder - will implement with backend later
        return Promise.resolve();
    };

    return (
        <div className="client-portal-cupones-container">
            {/* Active Coupons */}
            {activeCoupons.length > 0 && (
                <section className="cupones-section">
                    <div className="section-header">
                        <h2 className="section-title">Cupones Disponibles</h2>
                        <button 
                            className="add-coupon-btn"
                            onClick={() => setShowAddCouponModal(true)}
                            title="Agregar cupón"
                        >
                            <FaPlus />
                        </button>
                    </div>
                    <div className="cupones-grid">
                        {activeCoupons.map((coupon) => (
                            <div key={coupon.coupon_id} className="coupon-card-v2">
                                {/* Header */}
                                <div className="coupon-header">
                                    <div className="coupon-info">
                                        <h3 className="coupon-title">{coupon.coupon_name}</h3>
                                        {coupon.local_name ? (
                                            <div className="coupon-location">
                                                <FaStore />
                                                <span>{coupon.local_name}</span>
                                            </div>
                                        ) : (
                                            <div className="coupon-location global">
                                                <FaStore />
                                                <span>Válido en todos los productos</span>
                                            </div>
                                        )}
                                    </div>
                                    {coupon.discount_percentage && (
                                        <div className="discount-badge">-{coupon.discount_percentage}%</div>
                                    )}
                                </div>

                                {/* Description */}
                                <p className="coupon-desc">{coupon.description}</p>

                                {/* Footer */}
                                <div className="coupon-footer">
                                    <div className="coupon-meta">
                                        <div className="coupon-code">
                                            <span className="code-label">CÓDIGO</span>
                                            <span className="code-value">{coupon.coupon_code}</span>
                                        </div>
                                        <div className={`coupon-expiry ${isExpiringSoon(coupon.valid_until) ? 'warning' : ''}`}>
                                            <FaClock />
                                            <span>{formatDate(coupon.valid_until)}</span>
                                        </div>
                                    </div>
                                    <button 
                                        className="qr-button"
                                        onClick={(e) => handleShowQR(coupon, e)}
                                    >
                                        <FaQrcode />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* Used Coupons */}
            {usedCoupons.length > 0 && (
                <section className="cupones-section">
                    <div className="section-header">
                        <h2 className="section-title">Usados</h2>
                    </div>
                    <div className="cupones-grid">
                        {usedCoupons.map((coupon) => (
                            <div key={coupon.coupon_id} className="coupon-card-v2 used">
                                <div className="used-badge">Usado</div>
                                <h3 className="coupon-title">{coupon.coupon_name}</h3>
                                {coupon.local_name && (
                                    <div className="coupon-location">
                                        <FaStore />
                                        <span>{coupon.local_name}</span>
                                    </div>
                                )}
                                <p className="coupon-desc">{coupon.description}</p>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* Empty State */}
            {activeCoupons.length === 0 && usedCoupons.length === 0 && (
                <div className="empty-state">
                    <div className="empty-icon">🎟️</div>
                    <h3>No tienes cupones por el momento</h3>
                    <p>Cuando tengas cupones disponibles, aparecerán aquí automáticamente</p>
                </div>
            )}

            {/* QR Code Modal */}
            <Modal
                show={showQRModal}
                onHide={() => setShowQRModal(false)}
                centered
                className="client-portal-qr-modal"
            >
                <div className="qr-modal-content">
                    <button className="qr-close" onClick={() => setShowQRModal(false)}>
                        <FaTimes />
                    </button>
                    
                    {selectedCoupon && (
                        <>
                            <h3 className="qr-title">{selectedCoupon.coupon_name}</h3>
                            <p className="qr-subtitle">Muestra este código al restaurante</p>
                            
                            <div className="qr-code-wrapper">
                                <QRCode 
                                    value={selectedCoupon.coupon_code} 
                                    size={220} 
                                    bgColor="#FFFFFF"
                                    fgColor="#FC7556"
                                    level="H"
                                />
                            </div>
                            
                            <div className="qr-code-text">
                                <span className="qr-label">CÓDIGO</span>
                                <span className="qr-value">{selectedCoupon.coupon_code}</span>
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {/* Add Coupon Modal */}
            <AddCoupon
                show={showAddCouponModal}
                onHide={() => setShowAddCouponModal(false)}
                onAddCoupon={handleAddCoupon}
            />
        </div>
    );
};

export default Cupones;
